import { MarketLayoutStylesSchema } from './MarketLayout.styles';
import bgRepeat from '@/assets/sterlingparker/images/backgrounds/bg-repeat.png';

export const matchDetailsStyles: MarketLayoutStylesSchema = {
  headerText: {
    flex: '1',
    align: 'center',
    fontSize: '2xs',
    fontWeight: 'bold',
  },

  rowWrapper: {
    px: '4',
    py: '2',
    alignItems: 'center',
    display: 'flex',
    fontSize: 'xs',
    fontWeight: 'bold',
    justifyContent: 'space-between',
    borderColor: 'transparent',
    borderTopWidth: undefined,
    gap: '2',
    pos: 'relative',

    _before: {
      borderColor: 'blackAlpha.400',
      borderBottomWidth: '1px',
      boxShadow: '0 1px rgba(255, 255, 255, .07)',
      content: '""',
      w: 'full',
      left: '0',
      pos: 'absolute',
      top: '-1px',
    },
  },
  rowWrapperFirst: {
    borderTopWidth: '1px',
  },
  rowWrapperWithBtn: {
    m: '2',
    mt: '0.5',
    borderRadius: 'md',
    bgImage: `url(${bgRepeat})`,
    bgRepeat: 'repeat',

    _before: { display: 'none' },
  },

  tab: {
    bg: 'beta.500',
    borderBottom: '1px',
    borderColor: 'beta.600',
    color: 'alpha.500',
    fontSize: '2xs',
    fontWeight: 'bold',
    _notFirst: { borderLeftWidth: '1px' },
    _selected: {
      bg: 'transparent',
      borderBottomColor: 'transparent',
      color: 'white',
    },
  },
};
